// extracted by mini-css-extract-plugin
module.exports = {"AboutUs":"_12bXYHKq","headerTwo":"_32ls7g45","Content":"_3iLME3Gy","rainmaker":"_1W3GYi6A","founderLogo":"_3ck1UgXQ","founderLogoVlad":"_3bUzP3E3","founderLogoMikeT":"WizbPNLb","founderDetail":"_2h0gVDWX","founderName":"_8wJHYTwo","founderDesc":"_2H_HgtdD"};
    if(module.hot) {
      // 1746735829869
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  